import { AfterViewInit, Directive, ElementRef } from '@angular/core';

/**
 * Move o foco para o host no instante em que ele entra no DOM — pensado para
 * os `<h1>` que substituem o conteúdo do card em troca de estado (ux.md §6:
 * "código expirado", "tentativas esgotadas", "escolha de empresa expirada").
 *
 * Sob `*ngIf`, Angular recria a view embutida a cada vez que a condição volta
 * a ser verdadeira — logo `ngAfterViewInit` roda de novo em cada transição,
 * sem precisar de `ViewChild` + `setTimeout` manual no componente host.
 *
 * O elemento precisa de `tabindex="-1"` no próprio template (este diretiva
 * não o adiciona — um `<h1>` focável sem isso não é óbvio pra quem lê o
 * markup, e `tabindex` é o tipo de atributo que vale estar visível ali).
 */
@Directive({
  standalone: true,
  selector: '[appFocusOnInit]'
})
export class FocusOnInitDirective implements AfterViewInit {
  constructor(private readonly el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    // Timeout 0: garante que o elemento já está pintado e, em telas que têm
    // uma região aria-live associada ao mesmo estado, que a mudança de texto
    // já foi commitada antes do foco mover (mesma ordem do precedente de
    // login-desambiguação).
    setTimeout(() => this.el.nativeElement.focus());
  }
}
